<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right"></div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="permissionName" label="权限名称"></el-table-column>
            <el-table-column prop="permissionSort" label="权限序号"></el-table-column>
            <el-table-column prop="permissionIcon" label="权限图标"></el-table-column>
            <el-table-column prop="permissionUrl" label="权限地址"></el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="110px">
                    <el-form-item label="权限名称">
                        <el-input v-model="handleInfo.permissionName"></el-input>
                    </el-form-item>
                    <el-form-item label="权限序号">
                        <el-input v-model="handleInfo.permissionSort"></el-input>
                    </el-form-item>
                    <el-form-item label="权限图标">
                        <el-input v-model="handleInfo.permissionIcon"></el-input>
                    </el-form-item>
                    <el-form-item label="权限地址">
                        <el-input v-model="handleInfo.permissionUrl"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, enumMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "PERMISSION";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>